// Authentication belongs to the platform account system, not to the currently
// viewed Wiki. This alias is only required by the upstream GameKee identity API.
export const GAMEKEE_IDENTITY_ALIAS = 'arcanatactics';
